import React, { Component } from 'react';
import WithRouterWrappedComponent from './withRouterWrappedComponent';

const withRouterHOC = WrappedComponent =>
  class extends Component {
    render() {
      return <WithRouterWrappedComponent wrappedComponentProps={this.props} WrappedComponent={WrappedComponent} />;
    }
  };

export default withRouterHOC;
